import { render, staticRenderFns } from "./Summary2.vue?vue&type=template&id=a3f27f60&"
import script from "./Summary2.vue?vue&type=script&lang=ts&"
export * from "./Summary2.vue?vue&type=script&lang=ts&"
import style0 from "./Summary2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports